import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Resolves the organization id that owns a given device, by looking up
 * its most recent assignment and the assigned user's organization.
 * Returns null if the device has no assignment.
 */
export const useDeviceOrganization = (deviceId?: string) => {
  return useQuery({
    queryKey: ["device-organization", deviceId],
    queryFn: async () => {
      if (!deviceId) return null;

      const { data: assignment, error: assignErr } = await supabase
        .from("device_assignments")
        .select("user_id, assigned_at")
        .eq("device_id", deviceId)
        .order("assigned_at", { ascending: false })
        .limit(1)
        .maybeSingle();

      if (assignErr) {
        console.error("Error fetching device assignment:", assignErr);
        return null;
      }
      if (!assignment?.user_id) return null;

      const { data: role, error: roleErr } = await supabase
        .from("user_roles")
        .select("organization_id")
        .eq("user_id", assignment.user_id)
        .not("organization_id", "is", null)
        .limit(1)
        .maybeSingle();

      if (roleErr) {
        console.error("Error fetching assigned user organization:", roleErr);
        return null;
      }

      return role?.organization_id ?? null;
    },
    enabled: !!deviceId,
  });
};
